import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import Loader from "../icons/Loader";
import "./DropDownInput.css";
import { useOutsideAlerter } from "../../util/useOutsideAlerter";
import { IoMdClose } from "react-icons/io";

const DropDownInput = forwardRef((props, ref) => {
  const [focused, setFocused] = useState(false);
  const [hasValue, setHasValue] = useState(
    props.value || props.defaultValue ? true : false
  );
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef, () => setFocused(false));
  let compRef = ref;
  const handleChange = (event) => {
    setHasValue(event.target.value ? true : false);
    props.onChange && props.onChange(event);
  };

  useEffect(() => {
    props.onFocusChange &&
      props.onFocusChange(
        (props.open !== undefined && !props.open ? false : focused) &&
          hasValue &&
          (props.dropItems?.length > 0 || props.dropLoading),
        focused
      );

    // console.log(
    //   props.open !== undefined ? props.open : focused,
    //   hasValue,
    //   props.dropItems?.length > 0,
    //   props.dropLoading
    // );
  }, [focused, hasValue, props.dropLoading, props.dropItems, props.open]);

  // Expose the focused state via the ref
  useImperativeHandle(compRef, () => ({
    isOpen: () => focused,
    focused: focused,
    close: () => setFocused(false),
    open: () => setFocused(true),
    selectAllInputValue: () => {
      wrapperRef.current.querySelector("input").select();
    },
    getWrapperRef: () => wrapperRef,
  }));

  return (
    <div
      ref={wrapperRef}
      className={`${props.noWrapperStyle ? '' : 'ui-input-wrapper'} mt-kit-24 relative z-[100] flex gap-kit-16 justify-center items-center px-kit-16 py-kit-4`}
      style={{ ...(props.style || {}) }}
      onClick={() => {
        // console.log("click");
        props.disabled && setFocused(!focused);
      }}
    >
      {props.icon && <div className="ui-input-icon">{props.icon}</div>}
      {props.label && (
        <label
          className={`ui-label absolute whitespace-nowrap top-[2rem] translate-y-[-50%] bg-[var(--inyc-primary)] duration-200 pointer-events-none  
        ${
          focused || hasValue || props.placeHolder
            ? "py-0 !top-[-18px] !left-0"
            : "translate-y-[100%]"
        }`}
        style={{
          fontSize: focused || hasValue || props.placeHolder ? '' : '1.1rem',
          marginLeft: focused || hasValue || props.placeHolder ? '0rem' : '0.5rem',
        }}
        >
          {props.label}
        </label>
      )}
      {props.renderValue ? (
        <div
          className={`ui-input cursor-pointer flex items-center ${
            props.disabled ? "pointer-events-none" : ""
          }`}
          style={{ padding: 0, width: '100%', ...props.inputStyle }}
          onClick={() => setFocused(true)}
        >
          {props.renderValue(props.value)}
        </div>
      ) : (
        <input
          className={`ui-input cursor-pointer ${
            props.disabled ? "pointer-events-none" : ""
          }`}
          style={{ padding: 0, width: '100%', ...props.inputStyle }}
          placeholder={props.placeHolder}
          ref={props.Ref}
          onChange={handleChange}
          value={props.value}
          onFocus={() => {
            setFocused(true);
          }}

          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              setFocused(false);
              // Blur the input to dismiss the keyboard
              if (props.Ref?.current) {
                props.Ref.current.blur();
              }
            }
            // Call custom onKeyDown if provided
            if (props.onKeyDown) {
              props.onKeyDown(e);
            }
          }}
          disabled={props.disabled}
          readOnly={props.readOnly}
        />
      )}
      {props.clearable && (
        <button
          type="button"
          aria-label={props.clearLabel || "clear"}
          className="flex-shrink-0 p-0 bg-transparent border-0 cursor-pointer leading-none -translate-x-[5px]"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            const input =
              props.Ref?.current || wrapperRef.current?.querySelector("input");
            const current = input?.value || "";
            if (!current) {
              props.onClearEmpty?.();
              return;
            }
            input.value = "";
            input.focus();
            setHasValue(false);
            props.onChange?.({ target: { value: "" } });
          }}
        >
          <IoMdClose size={16} color="var(--inyc-primary-text-color)" />
        </button>
      )}
      {props.showDropDownArrow && (
        <span aria-hidden="true" className={`inyc-field-chevron ${focused ? "is-open" : ""}`} onClick={() => setFocused(!focused)} />
      )}
      <div
        className={`inyc-menu is-field absolute left-0 right-0 z-[10] overflow-auto max-h-[500px] ${
          props.dropDownDirection === "top" ? "mb-kit-4" : "mt-kit-4"
        } grid duration-200 ${
          (props.open !== undefined && !props.open ? false : focused) &&
          hasValue &&
          (props.dropItems?.length > 0 || props.dropLoading)
            ? `grid-rows-[1fr] pointer-events-auto opacity-1 ${
                props.dropDownDirection === "top"
                  ? "bottom-[100%]"
                  : "top-[100%]"
              }`
            : `grid-rows-[0fr] opacity-0 ${
                props.dropDownDirection === "top" ? "bottom-[90%]" : "top-[90%]"
              } pointer-events-none`
        } ${props.dropDownClassName}`}
      >
        <div className="min-h-0">
          {props.dropLoading ? (
            <div className="dropdown-loader">
              <Loader />
            </div>
          ) : (
            <div>
              {props.dropItems &&
                props.dropItems.map((item, i) => {
                  if (props.ItemComponent) {
                    return (
                      <props.ItemComponent
                        key={i}
                        item={item}
                        onClick={() => {
                          setFocused(false);
                        }}
                      />
                    );
                  } else {
                    return (
                      <div
                        key={i}
                        className="inyc-menu-item"
                        onClick={() => {
                          setFocused(false);
                          item.onClick && item.onClick();
                        }}
                      >
                        {item.label}
                      </div>
                    );
                  }
                })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
});

const styles = {
  smallLabel: {
    transform: "scale(0.9)",
    fontSize: "var(--inyc-text-lg)",
    padding: "0 var(--inyc-space-8)",
    top: "-18px",
    left: "5px",
    // color: "#b6c8db",
    color: "var(--inyc-primary-color)",
  },
  dropDownContainer: {
    position: "absolute",
    zIndex: 10,
    top: "100%",
    left: "-1px",
    width: "100%",
    boxSizing: "content-box",
    backgroundColor: "white",
    border: "1px solid var(--inyc-divider)",
    borderTop: "none",
    boxShadow: "var(--inyc-shadow-sm)",
    maxHeight: "500px",
    overflowY: "scroll",
  },
};

export default DropDownInput;
